import React from 'react'
import { SettingsSectionV2 } from './SettingsSectionV2'

/* System → CRM: the CRM type and the Zoho keys. A Zoho key saved here drops the Zoho token, so the next Zoho call signs in with it. */
const GROUPS = [
  { key: 'crm', title: 'CRM', sub: 'Which CRM the backend reports users and deals to' },
  { key: 'zoho-api', title: 'Zoho · API', sub: 'The Self Client the backend signs in with: Client ID, Client secret and its refresh token' },
]

export function CrmSettingsV2() {
  return (
    <SettingsSectionV2
      title="CRM"
      intro="CRM type and Zoho keys. A value saved here replaces the ConfigMap one and works without a restart."
      groups={GROUPS}
      saveNote={(keys) => keys.some((k) => k.startsWith('ZOHO_'))
        ? 'The backend uses them from the next request — Zoho signs in again with the new values on its next call.'
        : 'The backend uses them from the next request.'}
    />
  )
}
